import { render, staticRenderFns } from "./listaServicos.vue?vue&type=template&id=083685ec&scoped=true&"
import script from "./listaServicos.vue?vue&type=script&lang=js&"
export * from "./listaServicos.vue?vue&type=script&lang=js&"
import style0 from "./listaServicos.vue?vue&type=style&index=0&id=083685ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083685ec",
  null
  
)

export default component.exports